import { useState } from 'react'
import { Dropdown, Button } from 'antd'
import { useAppContext } from '@/app/providers/baseProvider'
import { useSelector } from 'react-redux'
import { useLogoutRedirect } from '@/features/auth/api/logoutRedirect'
import { useTranslation } from 'react-i18next'
import { MenuOutlined, CheckCircleFilled, LeftOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons'
import type { RootState } from '@/app/store/store'
import { UsergroupAddOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

export default function HeaderMenu() {
  const navigate = useNavigate()
  const [menuVisible, setMenuVisible] = useState(false)

  const { isDarkMode, setColorMode } = useAppContext()
  const { idToken, originalAuth } = useSelector((state: RootState) => state.auth)
  const { userName, roles } = useSelector((state: RootState) => state.user)
  const isAdmin = roles.includes('frontend-admin')
  const { t } = useTranslation()

  const { mutate } = useLogoutRedirect({
    mutationConfig: {
      onSuccess: () => sessionStorage.clear(),
      onError: () => {},
    },
  })

  const menuItems: any[] = [
    {
      key: 'theme',
      label: t('headerMenu.theme'),
      icon: <LeftOutlined style={{ fontSize: 14 }} />,
      children: [
        {
          key: 'dark',
          icon: isDarkMode ? <CheckCircleFilled /> : <CheckCircleFilled style={{ visibility: 'hidden' }} />,
          label: t('headerMenu.dark'),
        },
        {
          key: 'light',
          icon: !isDarkMode ? <CheckCircleFilled /> : <CheckCircleFilled style={{ visibility: 'hidden' }} />,
          label: t('headerMenu.light'),
        },
      ],
    },
  ]

  menuItems.unshift({
    key: 'userDisplay',
    label: (
      <div className="user-display" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'default' }}>
        <UserOutlined />
        <span>{userName}</span>
      </div>
    ),
    className: 'user-display-item',
    onClick: undefined,
  })
  if (isAdmin) {
    menuItems.push({
      key: 'userManagement',
      label: t('User management'),
      icon: <UsergroupAddOutlined />,
      onClick: () => navigate('/user-management'),
    })
  }
  menuItems.push({
    type: 'divider' as const,
  })

  menuItems.push({
    key: 'logout',
    label: t('headerMenu.logout'),
    icon: <LogoutOutlined />,
    onClick: () => {
      mutate({ idToken: originalAuth?.idToken || idToken })
    },
  })

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: menuItems,
        onClick: ({ key }) => {
          if (key === 'dark') {
            setColorMode(true)
          }
          if (key === 'light') {
            setColorMode(false)
          }
        },
      }}
      open={menuVisible}
      onOpenChange={(v) => setMenuVisible(v)}
      placement="bottomLeft">
      <Button type="text" icon={<MenuOutlined />} style={{ fontSize: 20 }} />
    </Dropdown>
  )
}
